import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
// import store from './store'
// router.replace({ path: '*', redirect: '/' })
Vue.config.productionTip = false
Vue.use(VueResource)
const app = new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')

